import { render, staticRenderFns } from "./InputDateSplit.vue?vue&type=template&id=f296fb4a"
import script from "./InputDateSplit.vue?vue&type=script&lang=js"
export * from "./InputDateSplit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports